import React from 'react'
// import LoaderGif from "../../../assets/images/loading-gif.gif"
import LoadingVideo from "../../../assets/images/loading-gif.webm"

function index() {
    return (
        <div className='loader'>
            <div className='full-page-loader'>
                <video autoPlay loop muted playsInline width="400">
                    <source src={LoadingVideo} type="video/webm" />
                    <source src={LoadingVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    )
}

export default index